import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, Suspense, useContext, useEffect } from "react";
import { blockManifestReader } from "../../internal/read-block-manifest.js";
import { APIProvider } from "../../../utils/APIProvider.js";
import { ErrorBoundaryEditor } from "./ErrorBoundaryEditor.js";
export const BlockContext = createContext(undefined);
export function EditableBlock({ payload }) {
    if (!env.admin)
        throw new Error("`EditableBlock` can only be used in the admin environment");
    const info = useContext(BlockContext);
    const props = payload ?? {};
    props.blockStyle = info?.props?.attributes?.className?.replace("is-style-", "");
    useEffect(() => {
        const block = wp.data.select("core/block-editor").getBlock(info?.props.clientId);
        if (block && block.attributes) {
            // @ts-ignore
            block.attributes.props = payload;
        }
    }, [payload, info?.props.clientId]);
    if (!info)
        return null;
    const BlockComponent = blockManifestReader.value[info.name];
    if (!BlockComponent)
        return _jsx("div", { children: "Unable to load block component" });
    return (_jsx(ErrorBoundaryEditor, { children: _jsx(APIProvider, { children: _jsx(Suspense, { children: _jsx(BlockComponent, { ...payload }) }) }) }));
}
